import { render, staticRenderFns } from "./ItemEditorCardItem.vue?vue&type=template&id=52787f4f&scoped=true&"
import script from "./ItemEditorCardItem.vue?vue&type=script&lang=js&"
export * from "./ItemEditorCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditorCardItem.vue?vue&type=style&index=0&id=52787f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52787f4f",
  null
  
)

export default component.exports